import { useAuth, RedirectToSignIn } from "@clerk/clerk-react";
import { ReactNode } from "react";

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin: _requireAdmin = false }: ProtectedRouteProps) {
  const { isLoaded, isSignedIn } = useAuth();

  // Clerk가 로딩 중이면 로딩 표시
  if (!isLoaded) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  // 로그인 안됨 → 로그인 페이지로
  if (!isSignedIn) {
    return <RedirectToSignIn />;
  }

  // TODO: Admin 체크 - 현재는 서버에서 처리
  // _requireAdmin의 경우 서버 API 호출로 확인 필요

  return <>{children}</>;
}
